export default "__VITE_ASSET__Cf46g1FA__"